import {combineReducers} from '@reduxjs/toolkit';

import {entitlementRoleChangeLogStateSlice} from './slices/entitlement-role-change-log-state.slice';
import {entitlementRoleChangeLogSlice} from './slices/entitlement-role-change-log.slice';

export const entitlementRoleChangeLogReducer = combineReducers({
    events: entitlementRoleChangeLogSlice.reducer,
    state: entitlementRoleChangeLogStateSlice.reducer,
});
